export const userData = [
  {
    name: 'Jan',
    "Active User": 4000,
  },
  {
    name: 'Fab',
    "Active User": 3000,
  },
  {
    name: 'Mar',
    "Active User": 5000,
  },
  {
    name: 'Apr',
    "Active User": 4000,
  },
  {
    name: 'May',
    "Active User": 3000,
  },
  {
    name: 'Jun',
    "Active User": 2000,
  },
  {
    name: 'Jul',
    "Active User": 4000,
  },
  {
    name: 'Agu',
    "Active User": 3000,
  },
  {
    name: 'Sep',
    "Active User": 4000,
  },
  {
    name: 'Oct',
    "Active User": 1000,
  },
  {
    name: 'Nov',
    "Active User": 4000,
  },
  {
    name: 'Dec',
    "Active User": 3000,
  },

];

export const productData = [
  {
    name: 'Jan',
    "Sales": 4000,
  },
  {
    name: 'Fab',
    "Sales": 3000,
  },
  {
    name: 'Mar',
    "Sales": 5000,
  }

];

export const userRows = [
  {
    id: 1,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 2,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 3,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 4,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 5,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 6,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 7,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },
  {
    id: 8,
    username: 'John Snow',
    avatar: 'https://cdn.pixabay.com/photo/2016/11/21/12/42/beard-1845166_960_720.jpg',
    email: 'john@gmail.com', status: 'active', transaction: '$150.00'
  },

];

export const productRows = [
  {
    id: 1,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 2,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 3,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 4,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 5,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 6,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 7,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },
  {
    id: 8,
    name: 'Apple Airpods',
    img: 'https://cdn.pixabay.com/photo/2021/02/13/03/30/airpods-6010254_960_720.jpg',
    stock: '100', status: 'active', price: '$100.00'
  },

];